import React from 'react';

const typeIcons = {
  checking: '🏦',
  savings: '💰',
  brokerage: '📈',
  retirement: '🪙',
  crypto: '🪙',
};

const Overview = ({ accounts }) => (
  <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
    <h2 className="text-lg font-medium text-gray-900 mb-4">Overview</h2>
    <div className="space-y-4">
      {accounts.map((acc) => (
        <div key={acc.name} className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-2xl">{typeIcons[acc.type] || '💼'}</span>
            <span className="text-gray-700 font-medium">
              {acc.name} – {acc.institution} <span className="text-xs text-gray-400">({acc.type.replace('_', ' ')})</span>
            </span>
          </div>
          <span className={`text-base font-semibold ${acc.balance < 0 ? 'text-red-500' : 'text-gray-900'}`}>
            {acc.balance < 0 ? '-' : ''}${Math.abs(acc.balance).toLocaleString()}
          </span>
        </div>
      ))}
      <div className="pt-2 text-sm text-blue-500 cursor-pointer">View all accounts · Add account</div>
    </div>
  </div>
);

export default Overview; 